import React, { useState } from "react";
import "./createAssociation.scss";
import StepAssociation1 from "../registration/components/stepAssociation1/StepAssociation1";
import StepAssociation2 from "../registration/components/stepAssociation2/StepAssociation2";
import StepAssociation3 from "../registration/components/stepAssociation3/StepAssociation3";

import { daProvinciaASigla } from "../../enums/province";
import { createAssociationWS } from "./api/createAssociation";
import { gestioneSnackbar } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import SnackBar from "../../components/snackbar/Snackbar";
import { setGlobalState } from "../../utils/state";

const CreateAssociation = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [nameAssociation, setNameAssociation] = useState("");
  const [indirizzo, setIndirizzo] = useState("");
  const [comune, setComune] = useState("");
  const [provincia, setProvincia] = useState("");
  const [dateOfFoundation, setDateOfFoundation] = useState("");
  const [description, setDescription] = useState("");
  const [selectedAssociationTopic, setSelectedAssociationTopic] = useState([]);
  const [activationCode, setActivationCode] = useState("");

  const nextStep = () => {
    setStep(step + 1);
  };
  const previousStep = () => {
    setStep(step > 1 ? step - 1 : 1);
  };

  const handleSubmit = () => {
    //I controlli sugli input li ho già fatti tutti quando premo next
    const body = {
      code_activation: activationCode,
      name: nameAssociation,
      description,
      address: indirizzo + ", " + comune + ", " + daProvinciaASigla[provincia],
      date_of_foundation: dateOfFoundation,
      topics: selectedAssociationTopic.toString(),
    };

    createAssociationWS({ body })
      .then((res) => {
        setGlobalState("admin", true);
        localStorage.setItem("admin", true);

        gestioneSnackbar(true, res, "success");
        navigate("/", { replace: true });
      })
      .catch((err) => gestioneSnackbar(true, err.message, "error"));
  };

  return (
    <div className="create-association-container">
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <SnackBar />
        {step === 1 ? (
          <StepAssociation1
            activationCode={activationCode}
            setActivationCode={setActivationCode}
            nextStep={nextStep}
            previousStep={() => navigate("/settings")}
          />
        ) : null}
        {step === 2 ? (
          <StepAssociation2
            nameAssociation={nameAssociation}
            setNameAssociation={setNameAssociation}
            indirizzo={indirizzo}
            setIndirizzo={setIndirizzo}
            comune={comune}
            setComune={setComune}
            provincia={provincia}
            setProvincia={setProvincia}
            dateOfFoundation={dateOfFoundation}
            setDateOfFoundation={setDateOfFoundation}
            description={description}
            setDescription={setDescription}
            nextStep={nextStep}
            previousStep={previousStep}
          />
        ) : null}
        {step === 3 ? (
          <StepAssociation3
            selectedAssociationTopic={selectedAssociationTopic}
            setSelectedAssociationTopic={setSelectedAssociationTopic}
            nextStep={handleSubmit}
            previousStep={previousStep}
            save={true}
          />
        ) : null}
      </div>
    </div>
  );
};

export default CreateAssociation;
